<section class="super-list-container" *ngIf="elements.length > 0">
     <element-from-list *ngFor="let item of elements" [element]="item" [activeElement]="currentPointID" (emittedPointValue)="emitPointValueClicked($event)" (reloadList)="reload($event)"></element-from-list>
</section>
<div class="field" *ngIf="elements.length === 0">
     <div class="alert alert-primary text-center">
          Il n'y a pas de résultat pour votre recherche
     </div>
     <skeleton-list></skeleton-list>
</div>